import request from '../utils'

const benefitApi = {
    benefitList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/benefit`)
        const res = await req;
        return res.body;
    }, 
    benefitDetail: async (modelingId, benefit) => {
        const req = request.get(`/api/modeling/${modelingId}/benefit/${benefit}`)
        const res = await req;
        return res.body;
    },
    benefitUpdate: async (modelingId, benefit) => {
        const req = request.put(`/api/modeling/${modelingId}/benefit/${benefit.id}`).send(benefit);
        const res = await req;
        return res.body;
    },
    benefitCreate: async (modelingId, benefit) => {
        const req = request.post(`/api/modeling/${modelingId}/benefit`).send(benefit);
        const res = await req;
        return res.body;
    },
    benefitDelete: async (modelingId, benefitId) => {
        const req = request.delete(`/api/modeling/${modelingId}/benefit/${benefitId}`);
        await req;
    }
};

export default benefitApi